export default __webpack_public_path__ + "static/media/sketch-circle.edf5aa26.svg";